import { apiGet, apiPost } from './api';

/**
 * Fetch overview dashboard context for the logged-in student
 */
export function getStudentDashboard() {
  return apiGet('/student/dashboard.php');
}

/**
 * Fetch list of batches enrolled by this student
 */
export function getMyBatches() {
  return apiGet('/student/my-batches.php');
}

/**
 * Fetch daily lectures for a batch cohort (requires validity verification)
 */
export function getMyLectures(courseId, batchId, params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiGet(`/student/my-lectures.php?course_id=${courseId}&batch_id=${batchId}${query ? '&' + query : ''}`);
}

/**
 * Fetch daily lectures for a specific module cohort with server-side pagination
 */
export function getModuleLectures(batchId, moduleId, params = {}) {
  if (moduleId === 'single' || !moduleId) {
    const query = new URLSearchParams(params).toString();
    return apiGet(`/student/module-lectures.php?batch_id=${batchId}${query ? '&' + query : ''}`);
  }
  const query = new URLSearchParams(params).toString();
  return apiGet(`/student/module-lectures.php?batch_id=${batchId}&module_id=${moduleId}${query ? '&' + query : ''}`);
}

/**
 * Fetch detailed classroom metadata (modules, progress, materials, announcements)
 */
export function getBatchClassroomDetails(batchId) {
  return apiGet(`/student/batch-classroom-details.php?batch_id=${batchId}`);
}

/**
 * Mark a specific lecture as completed by the student
 */
export function completeLecture(batchId, lectureId) {
  return apiPost('/student/complete-lecture.php', {
    batch_id: Number(batchId),
    lecture_id: Number(lectureId),
    action: 'complete'
  });
}

export function uncompleteLecture(batchId, lectureId) {
  return apiPost('/student/complete-lecture.php', {
    batch_id: Number(batchId),
    lecture_id: Number(lectureId),
    action: 'uncomplete'
  });
}

/**
 * Fetch all permanent revision practice courses
 */
export function getCommonCourses() {
  return apiGet('/student/common-courses.php');
}

/**
 * Fetch videos inside a revision practice course
 */
export function getCommonVideos(commonCourseId) {
  return apiGet(`/student/common-videos.php?common_course_id=${commonCourseId}`);
}

/**
 * Fetch fees and transactions ledger for the student
 */
export function getMyFees() {
  return apiGet('/student/get-my-fees.php');
}

/**
 * Pay pending installment online
 */
export function payInstallment(enrollmentId, installmentNumber, gateway, simulateFailure = false) {
  return apiPost('/student/pay-installment.php', {
    enrollment_id: enrollmentId,
    installment_number: installmentNumber,
    gateway,
    simulate_failure: simulateFailure
  });
}

/**
 * Create Razorpay Order for online payment
 */
export function createRazorpayOrder(payload) {
  return apiPost('/payments/create-razorpay-order.php', payload);
}

/**
 * Verify Razorpay payment and complete enrollment/installment on backend
 */
export function verifyRazorpayPayment(payload) {
  return apiPost('/payments/verify-razorpay-payment.php', payload);
}

/**
 * Submit teacher review
 */
export function submitTeacherReview(payload) {
  return apiPost('/student/submit-teacher-review.php', payload);
}

/**
 * Get existing teacher review for a specific batch and course
 */
export function getExistingTeacherReview(batchId, courseId) {
  return apiGet(`/student/get-existing-review.php?batch_id=${batchId}&course_id=${courseId}`);
}

/**
 * Update existing teacher review
 */
export function updateTeacherReview(payload) {
  return apiPost('/student/update-teacher-review.php', payload);
}

/**
 * Fetch current student notifications count
 */
export function getStudentNotifications() {
  return apiGet('/student/get-notifications.php');
}

/**
 * Mark a common course as seen/visited by the student
 */
export function markCommonCourseSeen(commonCourseId) {
  return apiPost('/student/mark-common-course-seen.php', {
    common_course_id: Number(commonCourseId)
  });
}

